import $ from 'jquery';
import iziToast, { IziToastPosition, IziToastSettings } from 'izitoast';
import 'izitoastcss';

function collectMessages(value: unknown): string[] {
    if (typeof value === 'string')
        return value.trim() ? [value.trim()] : [];
    if (Array.isArray(value))
        return value.flatMap(collectMessages);
    if (value && typeof value === 'object')
        return Object.values(value).flatMap(collectMessages);
    return [];
}

function problemMessages(content: unknown): string[] {
    if (!content || typeof content !== 'object')
        return collectMessages(content);

    const problem = content as {
        messages?: unknown;
        errors?: unknown;
        detail?: unknown;
        message?: unknown;
        title?: unknown;
    };
    const messages = [
        ...collectMessages(problem.messages),
        ...collectMessages(problem.errors),
        ...collectMessages(problem.detail),
        ...collectMessages(problem.message),
    ];

    if (messages.length === 0
        && problem.title !== 'One or more validation errors occurred.')
        messages.push(...collectMessages(problem.title));

    return [...new Set(messages)];
}

function escapeHtml(message: string): string {
    return message
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

export default class Toast {
    static show(type: string) {
        function showToast(message: string | JQuery.jqXHR<any>, timeout?: number, position?: IziToastPosition, params?: IziToastSettings) {

            iziToast[type]({
                message: message,
                timeout: timeout || 10000,
                position: position || 'bottomCenter',
                displayMode: 2,
                ...params
            });
        }

        return function (message: string | JQuery.jqXHR<any>, timeout?: number, position?: IziToastPosition, params?: IziToastSettings) {
            if (typeof message !== 'string' && 'responseText' in message) {
                if (message.responseText) {
                    if (message.responseText[0] !== '{' && message.responseText[0] !== '[')
                        showToast(message.responseText, timeout, position, params);
                    else {
                        try {
                            const content = JSON.parse(message.responseText);
                            const messages = problemMessages(content);
                            showToast(
                                messages.length > 0
                                    ? messages.map(escapeHtml).join('<br>')
                                    : 'Não foi possível concluir a operação.',
                                timeout,
                                position,
                                params);
                        } catch {
                            showToast(message.responseText, timeout, position, params);
                        }
                    }
                }
            } else
                showToast(message, timeout, position, params);
        };
    }

    static updateMessage = function (message) {
        $('body > .loading-container').find('.content-message').html(message || '');
    };

    static info = Toast.show('info');
    static success = Toast.show('success');
    static warning = Toast.show('warning');
    static error = Toast.show('error');

    static clear() {
        iziToast.destroy();
    }
}
